
export function getAccountModifiedLimits(accountLimit, copy, administrator, ambito) {

    const modified = [];
    const administradora = administrator.Descripcion;

    accountLimit.forEach(function (element, index) {

        let elemCopy = copy.find(elem => elem.Id == element.Id);

        if (elemCopy !== undefined && (elemCopy.Valor != element.Valor)) {

            let mappedElement = {
                administradora: administradora,
                ambito: ambito,
                limiteAnterior: "$ " + elemCopy.Valor,
                limiteNuevo: "$ " + element.Valor
            }

            modified.push(mappedElement);
        }

    });

    return modified;
}

export function getEnterpriseModifiedLimits(enterpriseLimit, copy, administrator, ambito) {

    const modified = [];
    const administradora = administrator.Descripcion;

    //SOLO PARA PROBAR---LUEGO MODIFICAR
    enterpriseLimit = [];

    enterpriseLimit.forEach(function (element, index) {

        let elemCopy = copy.find(elem => elem.Id == element.Id);

        if (elemCopy !== undefined && (elemCopy.LimiteCompra != element.LimiteCompra)) {

            let mappedElement = {
                administradora: administradora,
                ambito: ambito,
                limiteAnterior: "$ " + elemCopy.LimiteCompra,
                limiteNuevo: "$ " + element.LimiteCompra
            }

            modified.push(mappedElement);
        }

    });

    return modified;
}